'use client';

import { Button } from '@bedrock/ui/button';
import { useIsUpTo } from 'hooks';

type ContentBlockWithMapButtonProps = {
  label: string;
};

export const ContentBlockWithMapButton = ({ label }: ContentBlockWithMapButtonProps) => {
  const isUpToMd = useIsUpTo('md');
  return (
    <Button className="w-full" size={isUpToMd ? 'md' : 'lg'} variant="primary">
      {label || 'Learn More'}
    </Button>
  );
};
